import { InjectionToken, Signal } from '@angular/core';

/** Injection token for the current database vertical signal, provided by data-access and defined in the domain layer to prevent UI & data-access circular dependencies. */
export const DATABASE_VERTICAL = new InjectionToken<Signal<string>>(
  'outlookDatabaseVerticalSignal',
);
